import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import Loading from '@shared/Loading';
import { Size2MixTabs, NetworkShell, TEST_PUC_NETWORK, TOPOLOGY_REF_TABS, useSize2MixRefNavigation, type TopologyRefTabId } from '@shared/size2mix-shell';
import type { PrototypeMeta } from '@shared/discoverPrototypes';
import { useTopology } from './hooks';
import EditorTab from './EditorTab';

export const meta: PrototypeMeta = {
    title: 'Référence — Topologie › Éditeur réseau',
    description:
        "Référence de Réseau › Topologie › Éditeur réseau (réseau test PUC) : carte sur la vraie géométrie, outils d'édition, sélection et modification du DN d'une canalisation.",
    tags: ['network', 'editor', 'reference'],
    author: 'dv5886',
    status: 'review',
    category: 'topology/editor',
    createdAt: '2026-10-20',
};

export default function RefTopologyEditor() {
    const nav = useSize2MixRefNavigation();
    const { data, isLoading } = useTopology();

    return (
        <PrototypeStudioLayout title={meta.title}>
            <NetworkShell network={TEST_PUC_NETWORK} activePage="topology" onNavigate={nav.onNetworkNavigate} onPrimaryNavigate={nav.onPrimaryNavigate}>
                <Size2MixTabs<TopologyRefTabId> tabs={TOPOLOGY_REF_TABS} activeId="editor" onChange={(id) => nav.goTo(TOPOLOGY_REF_TABS.find((t) => t.id === id)!.target)} />
                <div style={{ padding: '0 16px 16px' }}>
                    {isLoading || !data ? <Loading text="Chargement de la topologie" scale="md" /> : <EditorTab data={data} />}
                </div>
            </NetworkShell>
        </PrototypeStudioLayout>
    );
}
